import { render } from "./ProductsEditorPage.vue?vue&type=template&id=f32315b2&ts=true"
import script from "./ProductsEditorPage.vue?vue&type=script&lang=ts"
export * from "./ProductsEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__